/**
 * Drop-in replacement for HttpClientResponse.schemaBodyJson that strips
 * JSON-LD metadata (@id, @type, @context) from decoded responses.
 *
 * @example
 * ```ts
 * // Before:
 * HttpClientResponse.schemaBodyJson(ProductShow)(response)
 *
 * // After:
 * schemaBodyJsonClean(ProductShow)(response)
 * ```
 */

import type { Schema } from 'effect';
import { withoutJsonLd } from './withoutJsonLd';
import { withoutRest } from './withoutRest';
import * as HttpClientResponse from 'effect/unstable/http/HttpClientResponse';

// `withoutRest` is composed after `withoutJsonLd` so the named property set
// is JSON-LD-stripped first, then generated Record(String, Unknown) index
// signatures are removed from every Objects node. This keeps decoded values
// constrained to the named storefront contract.
export const schemaBodyJsonClean = <S extends Schema.Top>(schema: S) =>
  HttpClientResponse.schemaBodyJson(withoutRest(withoutJsonLd(schema)));
